import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";


const HighROI: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="High ROIs" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <b>High Dividends​</b>
                    <p>
                        <ul>
                            <li>Our low overheld licensing plus in-house testing and products production give high dividends</li>
                            <li>U.S. Section 1202 Economic Development Tax Incentive (new since 2024) may make our dividends Tax free !</li>
                            <li>We are predicted to give shareholders their investment amounts or more in dividends in the next 5-6 years</li>
                        </ul>
                    </p>{" "}
                    <b>Strong Valuation ROIs + Multiple Exits​​</b>
                    <p>
                        <ul>
                            <li>Valuation ROIs (10-yr.) should be 10:1 to 25:1 or more</li>
                            <li>We have several exit options starting as soon as year-3</li>
                        </ul>
                    </p>{" "}
                    <b>Information & Control​</b>
                    <p>
                        <ul>
                            <li>Our shareholders receive exclusive tech, business, and markets information to use to improve their positions ​</li>
                        </ul>
                    </p>{" "}
                    
                </div>
            </SubSection>
        </div>
    );
};

export default HighROI;